module.exports = __webpack_public_path__ + "img/bg2.fe3a54e4.png";